/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var CsvParserService = /** @class */ (function () {
            function CsvParserService() {
            }
            CsvParserService.prototype.parse = function (csv) {
                var textLines;
                var header;
                var lines = [];
                var footer = [];
                if (csv) {
                    textLines = csv.split(/\r\n|\n/);
                    header = textLines[0].split(/[,|](?=(?:[^"]*"[^"]*")*[^"]*$)/)
                        .map(function (field) { return field.trim().replace(/^"|"$/g, ''); });
                    for (var i = 1; i < textLines.length; i++) {
                        var data = textLines[i].split(/[,|](?=(?:[^"]*"[^"]*")*[^"]*$)/)
                            .map(function (field) { return field.trim().replace(/^"|"$/g, ''); });
                        if (data[0] === 'Total' || data[0] === 'Shop Average') {
                            footer = data;
                        }
                        else {
                            lines.push(data);
                        }
                    }
                }
                var csvReport = {
                    header: header,
                    dataRows: lines,
                    footer: footer,
                    rawData: csv
                };
                return csvReport;
            };
            return CsvParserService;
        }());
        Services.CsvParserService = CsvParserService;
        angular.module('app.Services')
            .service('csvParserService', CsvParserService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
